import React from "react";

const About = () => {
  return (
    <section className="bg-light">
      <div className="container px-5">
        <div className="row gx-5 justify-content-center">
          <div className="col-xxl-8">
            <div className="text-center my-5">
              <h2 className="display-5 fw-bolder">
                <span className="text-gradient d-inline">About Me</span>
              </h2>
              <p className="lead fw-light mb-4">
                Senior Backend Engineer & Solution Architect
              </p>
              <p className="text-muted">
                With 14+ years of experience in backend development, I build
                scalable and high-performance applications using Laravel,
                Symfony, Python, and FastAPI.
              </p>

              <p className="text-muted">
                Specialized in API development, DDD architecture, database
                optimization, and clean backend system design focused on
                performance and maintainability.
              </p>
              <div className="d-flex justify-content-center fs-2 gap-4">
                <a
                  className="text-gradient"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/dibya-mitra/"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <a
                  className="text-gradient"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/dibyamitr"
                >
                  <i className="bi bi-github"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
